<template lang="pug">
div
  y-dialog(v-if="showModal" v-model="showModal" scrollable max-width="600px" persistent :fullscreen="$vuetify.breakpoint.xsOnly")
    v-card
      v-card-title.pa-4.h6.basic800--text {{ $t('edit_message_template') }}
      v-divider.basic300
      v-card-text.pa-0
        div.label.basic600--text.text-uppercase.ma-4 {{ $t('insert_field') }}
        v-row.px-4(no-gutters)
          v-col.py-2(cols="6")
            y-checkbox(v-model="message.recipientName" :color="$vuetify.theme.themes[$theme].info500")
              template(v-slot:label)
                div.p2.my-auto {{ $t('recipient_name') }}
          v-col.py-2(cols="6")
            y-checkbox(v-model="message.customerName" :color="$vuetify.theme.themes[$theme].info500")
              template(v-slot:label)
                div.p2.my-auto {{ $t('customer_name') }}
          v-col.py-2(cols="6")
            y-checkbox(v-model="message.recipientPhone" :color="$vuetify.theme.themes[$theme].info500")
              template(v-slot:label)
                div.p2.my-auto {{ $t('recipient_phone') }}
          v-col.py-2(cols="6")
            y-checkbox(v-model="message.customerPhone" :color="$vuetify.theme.themes[$theme].info500")
              template(v-slot:label)
                div.p2.my-auto {{ $t('customer_phone') }}
          v-col.py-2(cols="6")
            y-checkbox(v-model="message.recipientAddress" :color="$vuetify.theme.themes[$theme].info500")
              template(v-slot:label)
                div.p2.my-auto {{ $t('recipient_address') }}
          v-col.py-2(cols="6")
            y-checkbox(v-model="message.orderMessage" :color="$vuetify.theme.themes[$theme].info500")
              template(v-slot:label)
                div.p2.my-auto {{ $t('customers_note') }}
          v-col.py-2(cols="6")
            y-checkbox(v-model="message.products" :color="$vuetify.theme.themes[$theme].info500")
              template(v-slot:label)
                div.p2.my-auto {{ $t('items_ordered') }}
          v-col.py-2(cols="6")
            y-checkbox(v-model="message.payment" :color="$vuetify.theme.themes[$theme].info500")
              template(v-slot:label)
                div.p2.my-auto {{ $t('payment') }}
          v-col.py-2(cols="6")
            y-checkbox(v-model="message.extraInfo" :color="$vuetify.theme.themes[$theme].info500")
              template(v-slot:label)
                div.p2.my-auto {{ $t('extra_info') }}
          v-col.py-2(cols="6")
            y-checkbox(v-model="message.scheduleDateTime" :color="$vuetify.theme.themes[$theme].info500")
              template(v-slot:label)
                div.p2.my-auto {{ $t('scheduled_date_time') }}
          v-col.py-2(cols="6")
            y-checkbox(v-model="message.receipt" :color="$vuetify.theme.themes[$theme].info500")
              template(v-slot:label)
                div.p2.my-auto {{ $t('link_to_receipt') }}
        .preview
          div.ma-4.label.basic600--text.text-uppercase {{ $t('message_preview') }}
          div.pa-3.mx-4(style="border:1px solid var(--v-basic400); border-radius: 4px;")
            div.p2.primary400--text {{ $t('order') }} #0001
            div.mt-3(v-if="message.recipientName || message.recipientPhone")
              div.p2.primary400--text {{ $t('recipient') }}
              div.p2.primary400--text(v-if="message.recipientName") {{ $t('name') }}: [ {{ $t('recipient_name') }} ]
              div.p2.primary400--text(v-if="message.recipientPhone") {{ $t('phone') }}: [ {{ $t('recipient_phone') }} ]
              div.p2.primary400--text(v-if="message.recipientPhone") WhatsApp: [ {{ $t('link_to_wa_recipient') }} ]
            div.mt-3(v-if="message.customerName || message.customerPhone")
              div.p2.primary400--text Customer
              div.p2.primary400--text(v-if="message.customerName") {{ $t('name') }}: [ {{ $t('customer_name') }} ]
              div.p2.primary400--text(v-if="message.customerPhone") {{ $t('phone') }}: [ {{ $t('customer_phone') }} ]
              div.p2.primary400--text(v-if="message.customerPhone") WhatsApp: [ {{ $t('link_to_wa_customer') }} ]
            div.mt-3(v-if="message.recipientAddress || message.products || message.scheduleDateTime")
              div.p2.primary400--text(v-if="message.recipientAddress") {{ $t('address') }}: [ {{ $t('recipient_address') }} ]
              div.p2.primary400--text(v-if="message.products") {{ $t('items') }}: [ {{ $t('items_ordered') }} ]
              div.p2.primary400--text(v-if="message.scheduleDateTime") {{ $t('expected') }}: [ {{ $t('scheduled_date_time') }} ]
            div.mt-3(v-if="message.orderMessage || message.extraInfo")
              div.p2.primary400--text(v-if="message.orderMessage") {{ $t('note') }}: [ {{ $t('customers_note') }} ]
              div.p2.primary400--text(v-if="message.extraInfo") {{ $t('extra_info') }}: [ {{ $t('extra_info') }} ]
            div.p2.primary400--text.mt-3(v-if="message.receipt") {{ $t('receipt') }}: [ {{ $t('link_to_receipt') }} ]
            div.p2.primary400--text.mt-3(v-if="message.payment") {{ $t('payment') }}: [ {{ $t('payment') }} ]
              
      v-card-actions
        v-spacer
        v-btn(color='white', text @click='resetDefault')
          .button-Aa-small.primary400--text {{ $t('reset_to_default') }}
        v-btn.mr-2(color='textColorAccent' depressed height=32 @click="saveMessage" dark :loading="isLoading")
          .button-AA-small.basic100--text {{ $t('save') }}

</template>

<script>
export default {
  name: 'RiderMessageTemplate',
  props: ['open', 'field', 'propRiderMessage', 'company'],
  data: () => ({
    isLoading: false,
    message: {
      recipientName: true,
      customerName: false,
      recipientPhone: true,
      customerPhone: false,
      recipientAddress: true,
      orderMessage: false,
      products: true,
      payment: true,
      extraInfo: false,
      scheduleDateTime: false,
      receipt: false
    }
  }),
  computed: {
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    riderMessage: {
      get() {
        return this.propRiderMessage
      },
      set(newValue) {
        this.$emit('update:propRiderMessage', newValue)
      }
    },
  },
  watch: {
  },
  mounted () {
    if (this.riderMessage) {
      this.message = { ...this.riderMessage.extra_data }
    }
  },
  methods: {
    saveMessage () {
      if (this.riderMessage) {
        this.$axios.patch(`/companies/${this.company.id}/settings/${this.riderMessage.id}`, { extra_data: this.message })
          .then(() => {
            this.showModal = false,
            this.$set(this.riderMessage, 'extra_data', this.message)
          })
          .catch(() => {

          })
      } else {
        let data = {
          name: 'yz.rider.message_template',
          value: 'template',
          extra_data: this.message
        }
        this.$axios.post(`/companies/${this.company.id}/settings/`, data)
          .then(() => {
            this.showModal = false
            this.$emit('refresh')
          })
          .catch(() => {})
      }
    },
    resetDefault () {
      this.message = {
        recipientName: true,
        customerName: false,
        recipientPhone: true,
        customerPhone: false,
        recipientAddress: true,
        orderMessage: false,
        products: true,
        payment: true,
        extraInfo: false,
        scheduleDateTime: false,
        receipt: false
      }
    }
  }
}
</script>

<style scoped>
</style>

<i18n>
{
  "en": {
    "edit_message_template": "Edit message template to rider",
    "insert_field": "Insert field",
    "recipient_name": "Recipient name",
    "recipient_phone": "Recipient phone",
    "customer_phone": "Customer phone",
    "customers_note": "Customer’s note",
    "items_ordered": "Items ordered",
    "link_to_receipt": "Link to receipt",
    "link_to_wa_customer": "Link to wa customer",
    "link_to_wa_recipient": "Link to wa recipient"
  },
  "id": {
    "edit_message_template": "Edit template pesanan rider",
    "insert_field": "Masukkan info",
    "recipient_name": "Nama penerima",
    "recipient_phone": "Nomor HP penerima",
    "customer_phone": "Nomor HP pelanggan",
    "customers_note": "Nota Pelanggan",
    "items_ordered": "Item pesanan",
    "link_to_receipt": "Link tanda terima",
    "link_to_wa_customer": "Link WhatsApp pelanggan",
    "link_to_wa_recipient": "Link WhatsApp penerima"
  }
}
</i18n>
